/** Q&A asistent pod blogovým článkem — čtenáři se ptají, GPT odpovídá z kontextu článku. */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ChatCircleDots, PaperPlaneTilt } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/blog`;

export default function BlogQa({ slug }) {
    const [items, setItems] = useState([]);
    const [q, setQ] = useState("");
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        axios.get(`${API}/posts/${slug}/qa`).then((r) => setItems(r.data.items)).catch(() => {});
    }, [slug]);

    const ask = async () => {
        const question = q.trim();
        if (question.length < 5) { toast.error("Napiš otázku (min. 5 znaků)"); return; }
        setBusy(true);
        try {
            const r = await axios.post(`${API}/posts/${slug}/ask`, { question });
            setItems([r.data, ...items]);
            setQ("");
        } catch (e) { toast.error(e.response?.data?.detail || "Odeslání selhalo"); }
        finally { setBusy(false); }
    };

    return (
        <section className="mt-10 border-t border-white/10 pt-6 space-y-4" data-testid="blog-qa">
            <h2 className="font-display font-black text-lg uppercase tracking-tight flex items-center gap-2">
                <ChatCircleDots size={18} className="text-fa-mint" /> Zeptej se k analýze
            </h2>
            <div className="flex gap-2">
                <input value={q} onChange={(e) => setQ(e.target.value)} maxLength={300}
                       onKeyDown={(e) => e.key === "Enter" && !busy && ask()}
                       placeholder="Např.: Vyplatí se jako kapitán na GW1?"
                       className="flex-1 bg-black/40 border border-white/15 px-3 py-2 font-mono text-[12px] focus:outline-none focus:border-fa-mint placeholder:text-white/25"
                       data-testid="blog-qa-input" />
                <button type="button" onClick={ask} disabled={busy} data-testid="blog-qa-submit"
                        className="font-mono text-[10px] uppercase tracking-widest px-4 py-2 bg-fa-mint text-black font-bold hover:opacity-90 disabled:opacity-40">
                    <PaperPlaneTilt size={12} weight="fill" className="inline mb-0.5 mr-1" /> {busy ? "Přemýšlím…" : "Zeptat se"}
                </button>
            </div>
            <div className="space-y-3">
                {items.map((it) => (
                    <div key={it.id} className="border border-white/10 bg-[#0d0d0d] p-3" data-testid={`blog-qa-item-${it.id}`}>
                        <p className="font-mono text-[11px] text-fa-sky font-bold">Q: {it.question}</p>
                        <p className="text-white/75 text-sm mt-1.5 leading-relaxed">{it.answer}</p>
                        <p className="font-mono text-[8px] text-white/30 mt-1.5">{new Date(it.created_at).toLocaleString("cs")} · AI asistent Fantasy Academy</p>
                    </div>
                ))}
            </div>
        </section>
    );
}
